import React from "react";
import { Link } from "react-router-dom";

import create_user from "./create_user.png";

const AddNewUser = () => (
  <div id="admin_add_user" className="section">
    <h2>3.1 Add New User</h2>
    <img src={create_user} alt="Create User" className="center" />
    <p>Here you can add users to a portal. In this example we add a user named 'Example User'</p>
    <ul>
      <li>
        <p>Under "Email", enter the e-mail address of the user you wish to add.</p>
      </li>
      <li>
        <p>
          A link will be sent to the user which will allow them to set a password, if you choose to
          send them a welcome email. Alternatively, you can send them a password reset email, or
          they can use the Forgot Password facility from the login screen, at any time.
        </p>
      </li>
      <li>
        <p>Enter your user's first and last names as prompted.</p>
      </li>
      <li>
        <p>
          (Expires - Optional) Not available if you have licenced courses with expiry dates - should
          you wish to restrict the user's length of access to the portal, click to place a tick in
          the 'Expires' box and enter the amount of days in numbers that you wish to limit access
          to. The created and expiry dates are shown.
        </p>
      </li>
      <li>
        <p>Assigned courses - tick the relevant boxes to assign your user to specific courses.</p>
      </li>
      <li>
        <p>
          Choose your preference as to whether or not you email the user their credentials, options
          include:
        </p>
        <ul>
          <li>
            Email access details to user - this will use the default Welcome template, or portal's
            own welcome template if it has been created.
          </li>
          <li>
            Email access details to user [Preview First] - the user will be created, then you'll be
            able to view and edit the email before sending it.
          </li>
          <li>
            <u>Don't</u> email access details to user. Please note, the user will not be sent a link
            to change their password.
          </li>
        </ul>
        <p>
          For more information{" "}
          <Link to="/help/user_administration/adding_a_new_user/emailing_user_credentials">
            click here.
          </Link>
        </p>
      </li>
      <li>
        <p>
          Click <strong>Create User</strong>.
        </p>
      </li>
    </ul>
    <p>Upon creation, you'll be taken to the edit page for the user you've just created.</p>
  </div>
);

export default AddNewUser;
